import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ControlError } from '../../models';

@Component({
  selector: 'kt-html-input',
  templateUrl: './html-input.component.html',
  styleUrls: ['./html-input.component.scss'],
})
export class HtmlInputComponent {
  private _control: FormControl;
  required: boolean;
  inFocus: boolean;
  modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ script: 'sub' }, { script: 'super' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code-block'],
      ['link'],
      ['clean'],
    ],
  };
  @Input() readonly: boolean;
  @Input() id: string;
  @Input() placeholder: string;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'neutral' = 'neutral';
  @Input() errors: ControlError[] = [];
  @Input()
  set control(control: FormControl) {
    if (!control) return;

    this._control = control;
    this.required = false;

    if (control.validator) {
      const validator = control.validator({} as any);
      this.required = !!validator?.required;
    }
  }
  get control(): FormControl {
    return this._control;
  }
  @Output() focused = new EventEmitter();
  @Output() blurred = new EventEmitter();
}
